import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import styles from './FieldCustomerName.module.scss';

const FieldCustomerName = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'payment-form-customerName',
    defaultMessage: 'Customer'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField<string>({name: 'customerName'});

  return (
    <InputText
      {...field}
      {...meta}
      variant={'full'}
      id={field.name}
      label={
        <div className={styles.labelContainer}>
          <span>{labelText}</span>
        </div>
      }
      defaultValue={field.value}
      placeholder={placeholder}
      autoComplete={'address-level4'}
    />
  );
};

export default FieldCustomerName;
